export default function objectIsEmpty(obj: any) {
  return (
    (!obj && obj !== 0 && obj !== false) ||
    (Object.entries(obj).length === 0 && obj.constructor === Object) ||
    (Array.isArray(obj) && obj.length === 0)
  );
}
